import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const inventarioProTheme = {
  zendeskCustomerSupport: false,
  themeName: THEME_NAMES.inventario_pro,
  logoUrl: "https://cdn.nemuru.com/assets/logos/inventario-pro-logo.png",
  palette: {
    primary: {
      main: "#fa6009",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#1068c7",
      contrastText: "#ffffff",
    },
    text: {
      title: "#000000",
      primary: "#444",
      secondary: "#666",
    },
    info: {
      main: "#1068c7",
      contrastText: "#fff",
      light: "#a7d1ff",
    },
    warning: {
      main: "#f5aa5d",
      contrastText: "#ffffff",
      light: "#fff6e7",
    },
    error: {
      main: "#dc0723",
      contrastText: "#ffffff",
      light: "#ff8e9c",
    },
    success: {
      main: "#16a34a",
      contrastText: "#ffffff",
      light: "#6df39e96",
    },
    // additional colors
    dark: {
      main: "#00458f",
      accent: "#000",
      contrastText: "#ffffff",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#4dd970",
      approved: "#43b46f",
      analysing: "#2ea3f2",
      sent: "#1c69d4",
      cancelled: "#d8d8d8",
      denied: "#dc0723",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#fff",
  customBorderRadius: {
    button: 25,
    paper: 8,
    chip: 100,
  },
};
